// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"824":"cad5aa6a","951":"655f2da7"}[chunkId] + ".css";
};